export const authUrl = "/auth";
export const rootUrl = "http://localhost:3011";

export default {
  authUrl,
  rootUrl,
  url: rootUrl + '/graphql'
};
